import Banner from '../components/(home)/Banner';
import '../App.css';
import '../styles/colors.css';
import Description from '../components/(home)/Description';
import Drawings from '../components/(home)/Drawings';
import Pictures from '../components/(home)/Pictures';
import Ideas from '../components/(home)/Ideas';
import Notebooks from '../components/(home)/Notebooks';
import Channel from '../components/(home)/Channel';
import People from '../components/(home)/People';

function Home() {
  return (
    <div className="Home">
      <Banner />
      <Description />
      <Drawings />
      <Pictures />
      <Ideas />
      <Notebooks />
      <Channel />
      <People />
    </div>
  );
}

export default Home;
